// pdf.js, loaded the first time a report is shown (TGCLOUD-1868, plan D1), and never before: the
// legacy build is about a megabyte, and most of the app never draws a PDF.
//
// Two separate loads, because they fail separately:
//   - loadPdfJs(): the library (the legacy build, which Safari runs) and the files it asks the page
//     for (pdfBinaryData.js). Loaded once and shared; a failed load, such as a chunk missing after
//     a deploy, is forgotten so the next attempt tries again.
//   - startPdfWorker(): a NEW Web Worker for each document shown. The pane terminates it when the
//     document goes, so a document's memory goes with it, and two panes never share one.

let library = null;

/** The pdf.js library and the factory for the files it asks for. */
export function loadPdfJs() {
  if (!library) {
    library = Promise.all([
      import('pdfjs-dist/legacy/build/pdf.mjs'),
      import('./pdfBinaryData')
    ]).then(([pdfjs, binaryData]) => ({
      pdfjs,
      binaryDataFactoryFor: binaryData.binaryDataFactoryFor
    }));
    library.catch(() => {
      library = null;
    });
  }
  return library;
}

/** A new pdf.js worker. Refuses in a browser that cannot run one. */
export async function startPdfWorker() {
  if (typeof Worker === 'undefined') {
    throw new Error('This browser cannot run the report reader.');
  }
  const { createPdfWorker } = await import('./pdfWorkerClient');
  return createPdfWorker();
}
